if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('.share-button__button'), // main button
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          copyButton: this.querySelector('.share-button__copy'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          details: this.querySelector('details'),
        };

        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href;

        if (navigator.share) {
          // Native share supported
          this.elements.details?.setAttribute('hidden', '');
          this.elements.shareButton?.classList.remove('hidden');
          this.elements.shareButton?.addEventListener('click', () => {
            navigator.share({
              url: this.urlToShare,
              title: document.title,
            }).catch(err => {
              console.error('Share failed:', err);
            });
          });
        } else {
          // Fallback
          this.elements.details?.addEventListener('toggle', this.toggleDetails.bind(this));
          this.elements.copyButton?.addEventListener('click', this.copyToClipboard.bind(this));
          this.elements.closeButton?.addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.elements.details?.open) {
          this.elements.successMessage?.classList.add('hidden');
          if (this.elements.successMessage) {
            this.elements.successMessage.textContent = '';
          }
          this.elements.closeButton?.classList.add('hidden');
          this.elements.shareSummary?.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.classList.remove('hidden');
            this.elements.successMessage.textContent =
              window.accessibilityStrings?.shareSuccess || 'Link copied!';
          }
          this.elements.closeButton?.classList.remove('hidden');
          this.elements.closeButton?.focus();
        }).catch(err => {
          console.error('Copy failed:', err);
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) {
          this.elements.urlInput.value = url;
        }
      }

      close() {
        this.elements.details?.removeAttribute('open');
      }
    }
  );
}
